<template>
  <label :class="['panel-block', { 'is-active': active }]">
    <slot></slot>
  </label>
</template>

<script>
 export default {
   props: {
     active: {
       type: Boolean,
       default: false
     }
   }
 }
</script>
  
